/**
 * SDK Constants
 * Centralized constants for z-indices, dimensions, and configuration values
 */

export const Z_INDEX = {
  OVERLAY: 999999,
  MODAL: 1000000,
  LOADER: 1000,
} as const;

export const DIMENSIONS = {
  MIN_HEIGHT: 196,
  CONTAINER_MAX_WIDTH: '500px',
  CONTAINER_WIDTH_PERCENT: '90%',
  CONTAINER_HEIGHT_PERCENT: '90%',
  CONTAINER_MAX_HEIGHT: '600px',
  BUTTON_SIZE: 30,
  DEFAULT_IFRAME_WIDTH: '344px',
} as const;

export const ALLOWED_3DS_ORIGINS = [
  'https://sandbox.api.inflowpay.xyz',
  'https://dev.api.inflowpay.xyz',
  'https://pre-prod.api.inflowpay.xyz',
  'https://api.inflowpay.xyz',
] as const;

export const ELEMENT_IDS = {
  OVERLAY: 'inflowpay-sdk-overlay',
  LOADER: 'inflowpay-loader',
  LOADER_STYLES: 'inflowpay-loader-styles',
  THREE_DS_OVERLAY: 'inflowpay-3ds-overlay',
  THREE_DS_CLOSE: 'inflowpay-3ds-close',
} as const;

export const IFRAME_URLS = {
  PRODUCTION: 'https://iframe.inflowpay.com/iframe/checkout',
  SANDBOX: 'https://sandbox.iframe.inflowpay.com/iframe/checkout',
  PREPROD: 'https://preprod.iframe.inflowpay.com/iframe/checkout',
  DEVELOPMENT: 'https://dev.iframe.inflowpay.com/iframe/checkout',
  LOCAL: 'http://localhost:3010/iframe/checkout',
} as const;
